import React, { FC } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { CampaignType, CustomerOptimizationStrategy, DeviceSettings, InventorySettings } from '../../../../../api/interfaces'
import { CampaignDelivery } from '../../../../../api/interfaces/CampaignDelivery'
import { CampaignDeliveryForm } from '../../../../../components/targeting/TargetingForm/CampaignDeliveryForm'
import { InventoryAndDeviceSettingsForm } from '../../../../../components/targeting/TargetingForm/InventoryAndDeviceSettingsForm'
import { CampaignTrafficPriorityPicker } from '../../../CampaignTrafficPriorityPicker'

export interface IEditCampaignDeliveryStrategy {
  campaignType: CampaignType
  campaignDelivery: CampaignDelivery
  onCampaignDeliveryChanged: (delivery: CampaignDelivery) => void
}

export const EditCampaignDeliveryStrategy: FC<IEditCampaignDeliveryStrategy> = props => {
  const onBaseTargetingChanged = (delivery: CampaignDelivery) => {
    props.onCampaignDeliveryChanged(delivery)
  }

  const onInventorySettingsChange = (inventorySettings: InventorySettings) => {
    props.onCampaignDeliveryChanged({ ...props.campaignDelivery, inventorySettings })
  }

  const onDeviceSettingsChange = (deviceSettings: DeviceSettings) => {
    props.onCampaignDeliveryChanged({ ...props.campaignDelivery, deviceSettings })
  }

  const onOptimizationChange = (customerOptimizationStrategy: CustomerOptimizationStrategy) => {
    props.onCampaignDeliveryChanged({ ...props.campaignDelivery, customerOptimizationStrategy })
  }

  if (props.campaignType === CampaignType.Billboard) {
    return <></>
  }

  return (
    <>
      <CampaignDeliveryForm baseDelivery={props.campaignDelivery} onTargetingChanged={onBaseTargetingChanged} campaignType={props.campaignType} />
      <EuiSpacer />
      {props.campaignType === CampaignType.Internet && props.campaignDelivery.inventorySettings && props.campaignDelivery.deviceSettings && (
        <>
          <InventoryAndDeviceSettingsForm inventorySettings={props.campaignDelivery.inventorySettings} deviceSettings={props.campaignDelivery.deviceSettings} onInventorySettingsChange={onInventorySettingsChange} onDeviceSettingsChange={onDeviceSettingsChange} />
          <CampaignTrafficPriorityPicker customerOptimizationStrategy={props.campaignDelivery.customerOptimizationStrategy} onOptimizationStrategyChange={optimization => onOptimizationChange(optimization)} />
        </>
      )}
    </>
  )
}
